import React from "react";
import { Typography } from "@mui/material";
import ResponsiveDrawer from "views/components/ResponsiveDrawer";

function Privacy() {
  return (
    <ResponsiveDrawer>
      <div style={{ maxWidth: "calc(100vw - 48px)" }}>
        <Typography paragraph>プライバシーポリシー</Typography>
        現在、ユーザーのデータは取得していません。
      </div>
    </ResponsiveDrawer>
  );
}

export default Privacy;
